module.exports = __webpack_public_path__ + "img/account-profile.8e5f2a46.svg";